var $710968c2c3e0117a$exports = {};
$710968c2c3e0117a$exports = {
    "close": `Zav\u{159}\xedt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`,
            other: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`
        })}.`
};


export {$710968c2c3e0117a$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
